import { nanoid } from 'nanoid/non-secure';

import { getTrackingService } from './TrackingServiceInstance';
import { enqueue } from '../core/perspective-tracking-api';

import type { NormalizedData } from '$lib/types/NormalizedData';

export const track = (event: string, data: any) => {
    const normalizedData = normalizeData('track', data);
    normalizedData.event = event;

    return enqueue('/t', normalizedData);
};

export const page = (pageName: string, data: any) => {
    const normalizedData = normalizeData('page', data);
    normalizedData.name = pageName;

    return enqueue('/p', normalizedData);
};

export const normalizeData = (type: string, data: any): NormalizedData => {
    const now = new Date().toISOString();

    return {
        timestamp: now,
        sentAt: now,
        context: {
            page: {
                path: window.location.pathname,
                referrer: document.referrer,
                search: window.location.search,
                title: document.title,
                url: window.location.href,
            },
            userAgent: window.navigator.userAgent,
            locale: window.navigator.language,
        },
        properties: data,
        messageId: `perspective-${nanoid()}`,
        type: type,
        anonymousId: getTrackingService().userId,
    };
};

export default {
    track,
    page,
};
